export const PHONE_MASK = '+48 999-999-999';
export const PHONE_REGEX = /^(\+48 )?\d{3}-?\d{3}-?\d{3}$/;
export const EMAIL_REGEX = /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;



// WEBPACK FOOTER //
// ./src/constants/formats.js